export const shouldReturnToCurrentPageAfterAuth =
    "GW_AUTH_RETURN_TO_SAME_PAGE" in window &&
    window.GW_AUTH_RETURN_TO_SAME_PAGE === true;
